import { useNavigate, type NavigateOptions } from 'react-router-dom';

export const AGENT_STUDIO_BASE_PATH = '/agent-studio';

export function agentStudioPath(path = '') {
  const clean = path.replace(/^\/+/, '');
  return clean ? `${AGENT_STUDIO_BASE_PATH}/${clean}` : AGENT_STUDIO_BASE_PATH;
}

export function useAgentStudioNavigate() {
  const navigate = useNavigate();

  return (to: string | number, options?: NavigateOptions) => {
    if (typeof to === 'number') {
      navigate(to);
      return;
    }

    const next = to.startsWith('/') ? agentStudioPath(to) : to;
    navigate(next, options);
  };
}
